import { render, staticRenderFns } from "./OrdenesPagos.vue?vue&type=template&id=2eb00790"
import script from "./OrdenesPagos.vue?vue&type=script&lang=js"
export * from "./OrdenesPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports